import { render, staticRenderFns } from "./zdbookactive.vue?vue&type=template&id=6cb87403&scoped=true"
import script from "./zdbookactive.vue?vue&type=script&lang=js"
export * from "./zdbookactive.vue?vue&type=script&lang=js"
import style0 from "./zdbookactive.vue?vue&type=style&index=0&id=6cb87403&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb87403",
  null
  
)

export default component.exports